import React from 'react';
import PropTypes from 'prop-types';
import { useOne } from 'context/ResourceProvider/hooks/useOne';
import { useIntersectionObserver } from 'hooks/useIntersectionObserver/index';
import { Card } from '../DocumentItem/Card';

export const LazyDocument = (props) => {
  const { resource, documentId, type, placeholder, width, height = 60 } = props;
  const [ref, entry] = useIntersectionObserver();
  const { loading, data = {} } = useOne({
    resource,
    id: documentId,
    skip: !(entry && entry.isIntersecting),
  });

  const content = React.useMemo(() => {
    if (type === 'card') {
      return (
        <Card
          url={data && data.url}
          downloadUrl={data && data.downloadUrl}
          fileName={data && data.fileName}
          mimeType={data && data.mineType}
          loading={loading}
          width={width}
          height={height}
        />
      );
    }
    return 'Picture';
  }, [type, data]);

  const renderContent = () => {
    if (!entry || !entry.isIntersecting) {
      return <>{placeholder}</>;
    }

    return <>{content}</>;
  };

  return (
    <div style={{ minHeight: height }} ref={ref}>
      {renderContent()}
    </div>
  );
};

LazyDocument.propTypes = {
  resource: PropTypes.string.isRequired,
  documentId: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['card', 'picture']),
  placeholder: PropTypes.node,
  height: PropTypes.number,
  width: PropTypes.number,
};

LazyDocument.defaultProps = {
  height: 60,
  placeholder: null,
  type: 'card',
  width: 60,
};
